import { Avatar } from '@sravni/react-design-system/lib/Avatar';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { Bank } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';

import styles from './BankTitle.module.scss';

type BankTitleProps = {
  logo?: string;
  title: string;
  subtitle?: string;
  button?: React.ReactNode;
  className?: string;
};

export const BankTitle = (props: BankTitleProps) => {
  const { logo, title, subtitle, button, className } = props;
  const isMobile = useIsMobile();

  return (
    <Space
      className={className}
      size={isMobile ? 12 : 16}
      align="center"
    >
      {logo ? (
        <Avatar
          className={styles.avatar}
          size={isMobile ? 36 : 44}
          src={logo}
        />
      ) : (
        <Icon
          size={28}
          icon={<Bank />}
        />
      )}

      <Space
        size={2}
        direction="column"
        className={styles.title}
      >
        <Heading
          level={isMobile ? 4 : 5}
          className="h-ellipsis"
        >
          {title}
        </Heading>

        {subtitle && (
          <Text
            className="h-color-D60 h-ellipsis"
            size={12}
          >
            {subtitle}
          </Text>
        )}
      </Space>
      {button}
    </Space>
  );
};
